export default "__VITE_ASSET__DBndT40n__"